/*
 *   File : view-rebalancing-history.jsx
 *   Author : https://evoqins.com
 *   Description :
 *   Integrations :
 *   Version : 1.0.0
 */

import React from "react";
import { DataTableComponent } from "../../Components/DataTable";
import Icon from "../../Components/icons";

const COLUMNS = [
  {
    name: "Date",
    selector: (row) => row.date,
    sortable: true,
    sortFunction: (a, b) => new Date(a.date) - new Date(b.date),
    width: "170px",
  },
  {
    name: " TRIGGERED BY",
    selector: (row) => row.trigger_by,
    sortable: true,
    sortFunction: (a, b) => a.trigger_by.localeCompare(b.trigger_by),
    width: "170px",
  },
  {
    name: "USERS IMPACTED",
    selector: (row) => row.user_impact,
    sortable: true,
    width: "170px",
  },
  {
    name: "CHANGES SUMMARY",
    sortable: true,
    width: "639px",
    cell: (row) => (
      <div className="d-flex justify-content-start flex-column e-font-14 e-font-weight-400 e-primary-font-poppins">
        <p className="m-0">Added fund: <span className="e-font-weight-600">{row.added_fund}</span>,
        allocation <span className=" e-font-weight-600">{row.allocation}%</span></p>
       <p className="m-0"> Changed allocation: <span className=" e-font-weight-600">{row.allocation_1}%</span> to <span className=" e-font-weight-600">{row.allocation_2} %</span> </p>
      </div>
    ),
  },
];

const DATA = [
  {
    date: "2025-08-01",
    trigger_by: "Admin",
    user_impact: 120,
    added_fund: "ABC Equity Fund",
    allocation: 25,
    allocation_1: 30,
    allocation_2: 10,
  },
  {
    date: "2025-08-02",
    trigger_by: "System",
    user_impact: 75,
    added_fund: "XYZ Debt Fund",
    allocation: 40,
    allocation_1: 20,
    allocation_2: 30,
  },
  {
    date: "2025-08-03",
    trigger_by: "Admin",
    user_impact: 200,
    added_fund: "Global Tech ETF",
    allocation: 35,
    allocation_1: 25,
    allocation_2: 45,
  },
  {
    date: "2025-08-04",
    trigger_by: "RM",
    user_impact: 60,
    added_fund: "Balanced Advantage Fund",
    allocation: 20,
    allocation_1: 10,
    allocation_2: 20,
  },
  {
    date: "2025-08-05",
    trigger_by: "System",
    user_impact: 150,
    added_fund: "Index Fund Nifty 50",
    allocation: 50,
    allocation_1: 35,
    allocation_2: 50,
  },
];



export default function ViewRebalanceHistory() {
  return (
    <div className="row px-3 pt-3">
      <DataTableComponent
        sortIcon={<Icon icon="sort_col" size="20px" />}
        columns={COLUMNS}
        data={DATA}
        className="e-content-management-table"
      />
    </div>
  );
}
